import { render, staticRenderFns } from "./room_details.vue?vue&type=template&id=055c7800&scoped=true&"
import script from "./room_details.vue?vue&type=script&lang=js&"
export * from "./room_details.vue?vue&type=script&lang=js&"
import style0 from "./room_details.vue?vue&type=style&index=0&id=055c7800&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055c7800",
  null
  
)

export default component.exports